<div class="closePopupImg">
    <img mat-dialog-close src="/icons/close-kb.svg" width="20px">
</div>
<div class="PopUpContent">
    <p>{{'common.text_brake_popup'|cxTranslate}}</p>
    <p><B><i>{{'common.text_brake_bold_popup'|cxTranslate}}</i></B></p>

    <div class="buttonContainer">
        <button class="btn btn-blue" (click)="newOne(_data)" mat-dialog-close>
            {{'common.text_ADB_newRequest'|cxTranslate}}
        </button>
        <button class="btn btn-blue" (click)="review(_data)" mat-dialog-close>
            {{'common.text_ADB_reviewRequest'|cxTranslate}}
        </button>
    </div>
</div>